<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center">
          <div class="row justify-content-center">
            <div class="text-center" style="margin-top: -3px">
              <h3 class="text-white">Reset password</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 ml-auto mr-auto">
      <form role="form" @submit.prevent="handleSubmit()">
        <card class="card-login card-plain">
          <div>
            <fg-input
              v-model="password"
              type="password"
              name="password"
              @keyup.native="validateForm()"
              class="no-border form-control-lg"
              placeholder="Password"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              :error="apiValidationErrors.password"
            >
            </fg-input>

            <fg-input
              v-model="password_confirmation"
              type="password"
              name="Password confirmation"
              @keyup.native="validateForm()"
              class="no-border form-control-lg"
              placeholder="Confirm Password"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              :error="apiValidationErrors.password_confirmation"
            >
            </fg-input>
          </div>

          <div slot="footer">
            <n-button
                :class="{disabled: !form_valid}"
                native-type="submit" type="primary" round block>
              Reset Password
            </n-button>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
const url = process.env.VUE_APP_API_BASE_URL;
export default {
  mixins: [formMixin],
  name: "login",
  data() {
    return {
      form_valid: false,
      password: "",
      password_confirmation: "",
      token: "",
      locale: '',
    };
  },

  mounted() {
    this.token = this.$route.query.hash;
    this.locale = this.$getLocale();
  },

  methods: {
    validateForm() {
      this.form_valid = (this.password && this.password_confirmation) && (this.password === this.password_confirmation);
    },
    async handleSubmit() {
      let user_data = {
        'password': this.password,
        'token': this.token,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/password-reset", requestOptions)
          .then(response => {
            this.$store.dispatch(
                "alerts/success",
                this.locale.password_changed
            );
            this.$router.push({path: '/login'});
          });
    },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
